import type { CSSObject } from '@emotion/react'
import { FocusIndicator, Shadow, ShadowElevation, Timing } from '@opallabs/gem'
import type { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = WithRequiredTheme

export const container = ({ theme }: StyleProps): CSSObject => ({
  ...Shadow[ShadowElevation.E1],
  transition: `box-shadow ${Timing.Fastest} ease-in-out`,

  '&:hover': {
    // NOTE: boxShadow override to keep
    // the shadow from getting cutoff on
    // right of Week View columns. This is
    // a manipulation of ShadowElevation.E2
    // that brings default 20px down to 10px
    boxShadow: '0 8px 10px 0 #00000029',
  },

  '&:focus': {
    boxShadow: [
      FocusIndicator[theme].boxShadow,
      Shadow[ShadowElevation.E2].boxShadow,
    ].join(', '),
    outline: 'none',
  },

  '@media (prefers-reduced-motion: reduced)': {
    transition: 'none',
  },
})
